import React from 'react';

type Props =
  | {
      className: string;
      name: string;
      accessibilitylabeldescription: string;
      children?: any;
    }
  | any;

const StaticMenuLink = ({
  name,
  className,
  activeColor,
  accessibilitylabeldescription,
  children,
  ...rest
}: Props) => (
  <span className={className} aria-label={accessibilitylabeldescription} {...rest}>
    {children || name}
  </span>
);

export default StaticMenuLink;
